import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateUserRole } from '../api/userManagementApi';
import { userKeys } from './userKeys';

/**
 * Mutation hook for updating a user's role.
 *
 * Errors are handled by the global QueryClient onError (shows snackbar).
 * Callers can override with mutate(data, { onSuccess, onError }).
 */
export const useUpdateUserRole = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ userId, roleId }: { userId: string; roleId: number }) =>
      updateUserRole(userId, { roleId }),

    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: userKeys.detail(variables.userId),
      });
      queryClient.invalidateQueries({ queryKey: userKeys.all });
    },
  });
};
